"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPressureLowOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.pressure-low_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "pressure-low_outline_svg__transparent_box" },
            React.createElement("path", { className: "pressure-low_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "pressure-low_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "pressure-low_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M17 21a10 10 0 10-2 0v2H6v2h20v-2h-9zM8 11a8 8 0 118 8 8 8 0 01-8-8zM6 28h20v2H6z" }),
            React.createElement("path", { d: "M14 11a2.09 2.09 0 00.07.51l-2.31 2.32 1.41 1.41 2.32-2.31A2.09 2.09 0 0016 13a2 2 0 10-2-2z" }))));
}
exports.default = SvgPressureLowOutline;
//# sourceMappingURL=PressureLowOutline.js.map